import * as React from 'react';
import { useState } from 'react';

type ImagesGalleryContextType = {
  isOpen: boolean;
  activeSlide: number;
  setActiveSlide: (index: number) => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const imagesGalleryContext = React.createContext<ImagesGalleryContextType>({
  isOpen: false,
  activeSlide: 0,
  setActiveSlide: () => {},
  setIsOpen: () => {},
});

export function ProductImagesGalleryProvider({ children }: React.PropsWithChildren<{}>) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  return (
    <imagesGalleryContext.Provider value={{ isOpen, setIsOpen, setActiveSlide, activeSlide }}>
      {children}
    </imagesGalleryContext.Provider>
  );
}

export function useProductImagesGalleryContext() {
  return React.useContext(imagesGalleryContext);
}
